module.exports = __webpack_public_path__ + "static/media/logo_alpha.117d261a.png";